import { Kge } from "../ws/dbKlassen/kge.model";

export class TableSelectKge extends Kge {
    isSelected!: boolean;

    public static getTableSelectKgeList(kgeList: Kge[]): TableSelectKge[] {
 
        let tableSelectKgeList: TableSelectKge[] = [];
    
        kgeList.forEach((entry) => {
          let tableSelectKge: TableSelectKge = Object.assign(new TableSelectKge(), entry);
          tableSelectKge.isSelected = true;
          tableSelectKgeList.push(tableSelectKge);
        });
    
        return tableSelectKgeList;
      }

      // TODO: sobald das Projekt weiter entwickelt wird und wurde dann kann das mit structuredClone ersetzt werden
      public static copyObject(tableSelectKga: TableSelectKge) : TableSelectKge
      {
 

        let newTableSelectKget: TableSelectKge = new TableSelectKge();

        newTableSelectKget.idKge = tableSelectKga.idKge
        newTableSelectKget.bezeichnung  = tableSelectKga.bezeichnung
        newTableSelectKget.kge  = tableSelectKga.kge
        newTableSelectKget.nutzungsdauer  = tableSelectKga.nutzungsdauer
        newTableSelectKget.isSelected  = tableSelectKga.isSelected

        return newTableSelectKget;
      }

      public static copyObjectList(tableSelectKgaList: TableSelectKge[]) : TableSelectKge[]
      {
 

        let newTableSelectKget: TableSelectKge[] = [];

        tableSelectKgaList.forEach((entry) => { 
          newTableSelectKget.push(this.copyObject(entry));
        });

        return newTableSelectKget;
      }
  }
  